import * as fromApp from '../reducers/app.reducer';
import * as fromDownload from '../reducers/download.reducer';
import { createSelector } from '@ngrx/store';

const selectDownload = (state: fromApp.AppState) => state.download;

export const selectDownloadManagementDownloading = createSelector(
    selectDownload,
    (state: fromDownload.State) => state.managementDownloading
);

export const selectDownloadLegalDownloading = createSelector(
    selectDownload,
    (state: fromDownload.State) => state.legalDownloading
);

export const selectDownloadTranslationDownloading = createSelector(
    selectDownload,
    (state: fromDownload.State) => state.translationDownloading
);

export const selectDownloadLocationDownloading = createSelector(
    selectDownload,
    (state: fromDownload.State) => state.locationDownloading
);
